/**
 * Additional Menu Links for drive ME
 * 
 * @author jjarolim
 */

import { LitElement, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { TW } from '../../shared'

const TwLitElement = TW(LitElement)

type AdditionalLink = {
    label: string
    url: string
    target: string
    icon: string
    class: string
}

/**
 * Sample Lit Element in assets/lit
 */
@customElement('additional-links')
export class AdditionalLinks extends TwLitElement {

    @property({ type: String })
    data?: string

    render() 
    {
        console.log( this.data )


        const additionalLinks = JSON.parse( this.data ?? '[]' )

        console.log( additionalLinks )

        return html`<div class="additional-links">
            ${ additionalLinks.map( (link: AdditionalLink) => html`
                <a class="button ${link.class} flex items-center justify-center gap-2 mb-2" href="${link.url}" target="${link.target}">
                    <span class="${link.icon} text-lg"></span>
                    ${link.label}
                </a>
            ` ) }
        </div>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'additional-links': AdditionalLinks
    }
}